import { useEffect } from 'react';
import { analyticsConstant, AnalyticsTransactionType } from 'types/analytics';

import { updatePaymentCompleted } from '../slices/pay-my-bill/slice';
import { qalTrackEventAction, qalTrackRenewalPaymentPurchaseAction } from '../thunks/analytics';
import { getDaysPriorPayment } from '../utils/analytics/helpers';
import { qalRenewalPaymentEcommerece } from '../utils/analytics/types';
import { useAppDispatch, usePayments, usePayMyBill } from './index';

export const useTrackRenewalPaymentComplete = () => {
  const { paymentReference = '', paymentState } = usePayments();

  const { paymentCompleted, policy } = usePayMyBill();

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!policy) return;
    const { dueDate = '', policyNumber = analyticsConstant.NOT_SET, dueAmount = 0 } = policy;
    // Fire Transaction Complete Event.

    if (paymentState === 'success' && !paymentCompleted && paymentReference) {
      dispatch(updatePaymentCompleted(true));

      // QAL Renewal Payment Ecommerce Payment
      dispatch(
        qalTrackRenewalPaymentPurchaseAction(
          qalRenewalPaymentEcommerece(paymentReference, policyNumber, dueAmount)
        )
      );
      const dayDifference = getDaysPriorPayment(dueDate);
      // Tracking Days Difference between due Date and Payment Completed Date.
      dispatch(
        qalTrackEventAction({
          eventAction: 'prior date complete payment',
          eventLabel: dayDifference.toString() || analyticsConstant.NOT_SET,
          data: {
            transactionType: AnalyticsTransactionType.renewalPayment,
          },
        })
      );
    }
  }, [dispatch, paymentCompleted, paymentReference, paymentState, policy]);
};
